import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj.data)
    } catch (_) {
      return null
    }
  }

  constructor ({ user_id, rol, email, name, token }) {
    this.id = user_id
    this.rol = rol
    this.email = email
    this.token = token
    this.name = name
    this.admin = false
  }

  get isAdmin () {
    return this.rol
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js